<template>
  <div>
    <div>{{ status }}</div>
    <div v-if="row.status == 'proceeding'">
      Progress: {{ progress }} %
      <b-button @click="getExportProgress" variant="outline-primary" class="border-0 px-2">
        <i class="fa fa-refresh" />
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColumnStatus',
  props: {
    row: {
      type: Object,
      default: {},
    },
    column: {
      type: String,
      default: {},
    },
  },
  data: () => {
    return {
      progress: 0,
    };
  },
  watch: {
    'row.status': function (newValue) {
      if (newValue == 'proceeding'){
        this.getExportProgress();
      } else {
        this.progress = 0;
      }
    }
  },
  methods: {
    getExportProgress() {
      this.getData(`export-requests/${this.row.id}/progress`, null, false).then(({data}) => {
        this.progress = data.progress.processed_percents;
        if (this.progress == 100){
          this.$emit('refreshTable');
        }
      });
    },
  },
  computed: {
    status() {
      return this.row[this.column];
    },
  },
};
</script>
